// Mock data pour l'encyclopédie de Lithothérapie

export const pierres = [
  {
    id: 1,
    nom: "Améthyste",
    nomScientifique: "Quartz violet",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Violet",
    origine: "Brésil, Uruguay, Madagascar",
    image: "https://images.unsplash.com/photo-1627768919962-fb6af351759c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "L'améthyste était considérée dans l'Antiquité comme une pierre de sobriété. Son nom vient du grec 'amethystos' signifiant 'non ivre'. Les Grecs croyaient qu'elle protégeait de l'ivresse.",
    propriétésÉnergétiques: "Pierre de sagesse et d'humilité, l'améthyste favorise la méditation, la concentration et l'élévation spirituelle. Elle aide à calmer les angoisses et les colères.",
    chakras: ["Couronne", "Troisième œil"],
    signesAstrologiques: ["Poissons", "Vierge", "Verseau", "Capricorne"],
    intentions: ["Méditation", "Stress", "Sommeil", "Spiritualité"],
    purification: "Eau distillée, fumigation à la sauge, bol tibétain",
    rechargement: "Lumière lunaire, amas de quartz, géode d'améthyste"
  },
  {
    id: 2,
    nom: "Quartz Rose",
    nomScientifique: "Quartz rose",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Rose",
    origine: "Madagascar, Brésil, Inde",
    image: "https://images.unsplash.com/photo-1560427450-00fa9481f01e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre d'amour par excellence depuis l'Antiquité, le quartz rose était utilisé par les Égyptiens comme élixir de beauté et de jeunesse.",
    propriétésÉnergétiques: "Pierre de l'amour inconditionnel et de la paix intérieure. Elle apaise les peines de cœur, favorise l'acceptation de soi et renforce la confiance en soi.",
    chakras: ["Cœur"],
    signesAstrologiques: ["Taureau", "Balance"],
    intentions: ["Amour", "Paix intérieure", "Confiance en soi", "Règles"],
    purification: "Eau déminéralisée, fumigation, sel indirect",
    rechargement: "Lumière lunaire, amas de quartz"
  },
  {
    id: 3,
    nom: "Citrine",
    nomScientifique: "Quartz jaune",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Jaune",
    origine: "Brésil, Madagascar, Russie",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre de lumière et d'abondance, la citrine était prisée par les marchands romains qui la considéraient comme une pierre de prospérité.",
    propriétésÉnergétiques: "Pierre de joie et d'abondance, elle stimule la créativité, attire la prospérité et dissipe les énergies négatives. Elle apporte chaleur et optimisme.",
    chakras: ["Plexus solaire"],
    signesAstrologiques: ["Gémeaux", "Lion", "Vierge"],
    intentions: ["Abondance", "Confiance", "Joie", "Stress"],
    purification: "Fumigation, son, eau courante",
    rechargement: "Soleil (courtes expositions), amas de quartz"
  },
  {
    id: 4,
    nom: "Labradorite",
    nomScientifique: "Feldspath plagioclase",
    formuleChimique: "(Ca,Na)(Al,Si)₄O₈",
    systemeCristallin: "Triclinique",
    dureteMohs: 6,
    couleur: "Gris iridescent",
    origine: "Canada, Madagascar, Finlande",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Découverte au Labrador au XVIIIe siècle, elle était vénérée par les peuples inuits qui croyaient qu'elle contenait les aurores boréales.",
    propriétésÉnergétiques: "Pierre de protection par excellence, elle absorbe les énergies négatives et forme un bouclier protecteur. Idéale pour les thérapeutes et les empathiques.",
    chakras: ["Tous les chakras"],
    signesAstrologiques: ["Gémeaux", "Cancer", "Sagittaire"],
    intentions: ["Protection", "Intuition", "Stress"],
    purification: "Eau distillée, fumigation, sel indirect",
    rechargement: "Lumière lunaire, amas de quartz"
  },
  {
    id: 5,
    nom: "Œil de Tigre",
    nomScientifique: "Quartz fibreux",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Brun doré",
    origine: "Afrique du Sud, Australie, Inde",
    image: "https://images.pexels.com/photos/1573236/pexels-photo-1573236.jpeg",
    histoire: "Pierre de protection des légionnaires romains qui la portaient comme talisman au combat. Son aspect rappelle l'œil d'un tigre vigilant.",
    propriétésÉnergétiques: "Pierre de protection, de courage et de confiance en soi. Elle repousse les énergies négatives et aide à prendre des décisions avec discernement.",
    chakras: ["Plexus solaire", "Racine"],
    signesAstrologiques: ["Gémeaux", "Lion", "Vierge"],
    intentions: ["Protection", "Confiance", "Ancrage"],
    purification: "Eau courante, fumigation, sel indirect",
    rechargement: "Soleil, terre"
  },
  {
    id: 6,
    nom: "Pierre de Lune",
    nomScientifique: "Feldspath",
    formuleChimique: "(Na,K)AlSi₃O₈",
    systemeCristallin: "Monoclinique",
    dureteMohs: 6,
    couleur: "Blanc nacré",
    origine: "Inde, Sri Lanka, Madagascar",
    image: "https://images.unsplash.com/photo-1560427450-00fa9481f01e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre sacrée en Inde, associée à la déesse lunaire. Les Romains pensaient qu'elle était formée de rayons de lune solidifiés.",
    propriétésÉnergétiques: "Pierre de féminité et d'intuition, elle équilibre les émotions, favorise la fertilité et harmonise les cycles féminins. Excellente pour accompagner les règles.",
    chakras: ["Sacré", "Troisième œil"],
    signesAstrologiques: ["Cancer", "Poissons", "Capricorne"],
    intentions: ["Intuition", "Féminité", "Règles", "Émotions"],
    purification: "Eau distillée, fumigation",
    rechargement: "Lumière lunaire exclusivement"
  },
  {
    id: 7,
    nom: "Cornaline",
    nomScientifique: "Calcédoine",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Orange à rouge",
    origine: "Inde, Brésil, Uruguay",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre sacrée des Égyptiens, symbole de vie et de renaissance. Elle ornait les amulettes funéraires pour protéger le défunt.",
    propriétésÉnergétiques: "Pierre de vitalité et de créativité, elle stimule l'énergie physique, favorise la confiance en soi et aide à surmonter les blocages émotionnels.",
    chakras: ["Sacré", "Plexus solaire"],
    signesAstrologiques: ["Taureau", "Vierge", "Bélier"],
    intentions: ["Vitalité", "Créativité", "Confiance", "Règles"],
    purification: "Eau courante, fumigation",
    rechargement: "Soleil, amas de quartz"
  },
  {
    id: 8,
    nom: "Lapis-Lazuli",
    nomScientifique: "Roche métamorphique",
    formuleChimique: "(Na,Ca)₈(AlSiO₄)₆(S,SO₄,Cl)₁₋₂",
    systemeCristallin: "Cubique",
    dureteMohs: 5.5,
    couleur: "Bleu profond",
    origine: "Afghanistan, Chili, Russie",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre royale par excellence, elle ornait les masques funéraires des pharaons. Symbole de pouvoir et de vérité dans l'Égypte antique.",
    propriétésÉnergétiques: "Pierre de sagesse et de vérité, elle stimule l'intellect, favorise la communication authentique et développe l'intuition.",
    chakras: ["Gorge", "Troisième œil"],
    signesAstrologiques: ["Sagittaire", "Poissons"],
    intentions: ["Communication", "Sagesse", "Intuition", "Stress"],
    purification: "Fumigation exclusivement (sensible à l'eau)",
    rechargement: "Lumière lunaire, amas de quartz"
  },
  {
    id: 9,
    nom: "Jaspe Rouge",
    nomScientifique: "Quartz microcristallin",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Rouge brique",
    origine: "Inde, Brésil, Madagascar",
    image: "https://images.unsplash.com/photo-1627768919962-fb6af351759c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre de force vitale utilisée par les guerriers pour le courage. Les Égyptiens la gravaient avec des formules magiques.",
    propriétésÉnergétiques: "Pierre d'ancrage et de vitalité, elle renforce l'énergie physique, stimule la circulation sanguine et aide lors des règles douloureuses.",
    chakras: ["Racine"],
    signesAstrologiques: ["Bélier", "Scorpion"],
    intentions: ["Ancrage", "Vitalité", "Règles", "Force"],
    purification: "Eau courante, fumigation, sel",
    rechargement: "Soleil, terre"
  },
  {
    id: 10,
    nom: "Aventurine Verte",
    nomScientifique: "Quartz",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Vert",
    origine: "Inde, Brésil, Russie",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre de prospérité et de chance, utilisée traditionnellement par les joueurs pour attirer la fortune.",
    propriétésÉnergétiques: "Pierre de prospérité et de croissance, elle apaise les émotions, favorise la guérison du cœur et attire les opportunités positives.",
    chakras: ["Cœur"],
    signesAstrologiques: ["Taureau", "Cancer"],
    intentions: ["Prospérité", "Guérison émotionnelle", "Stress"],
    purification: "Eau, fumigation, sel indirect",
    rechargement: "Soleil doux, lumière lunaire"
  },
  {
    id: 11,
    nom: "Obsidienne Noire",
    nomScientifique: "Verre volcanique",
    formuleChimique: "SiO₂ (70-75%)",
    systemeCristallin: "Amorphe",
    dureteMohs: 5.5,
    couleur: "Noir",
    origine: "Mexique, Islande, Japon",
    image: "https://images.pexels.com/photos/1573236/pexels-photo-1573236.jpeg",
    histoire: "Utilisée par les Aztèques pour fabriquer des miroirs divinatoires et des armes rituelles. Pierre de vérité et de protection.",
    propriétésÉnergétiques: "Pierre de protection puissante et d'ancrage, elle révèle les vérités cachées, absorbe les énergies négatives et aide à libérer les blocages émotionnels.",
    chakras: ["Racine"],
    signesAstrologiques: ["Scorpion", "Sagittaire"],
    intentions: ["Protection", "Vérité", "Ancrage"],
    purification: "Eau courante, fumigation, sel",
    rechargement: "Terre, soleil"
  },
  {
    id: 12,
    nom: "Amazonite",
    nomScientifique: "Feldspath",
    formuleChimique: "KAlSi₃O₈",
    systemeCristallin: "Triclinique",
    dureteMohs: 6.5,
    couleur: "Bleu-vert",
    origine: "Brésil, Russie, États-Unis",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre des guerrières amazones selon la légende. Utilisée en Égypte ancienne pour orner les bijoux et amulettes.",
    propriétésÉnergétiques: "Pierre de communication et d'apaisement, elle calme le système nerveux, favorise l'expression authentique et protège des ondes électromagnétiques.",
    chakras: ["Gorge", "Cœur"],
    signesAstrologiques: ["Vierge"],
    intentions: ["Communication", "Stress", "Apaisement"],
    purification: "Fumigation, eau distillée courte durée",
    rechargement: "Lumière lunaire, amas de quartz"
  },
  {
    id: 13,
    nom: "Turquoise",
    nomScientifique: "Phosphate d'aluminium",
    formuleChimique: "CuAl₆(PO₄)₄(OH)₈·4H₂O",
    systemeCristallin: "Triclinique",
    dureteMohs: 6,
    couleur: "Bleu turquoise",
    origine: "Iran, Chine, États-Unis",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre sacrée des Amérindiens et des pharaons égyptiens. Symbole de protection céleste et de communication divine.",
    propriétésÉnergétiques: "Pierre de purification et de protection, elle renforce le système immunitaire, favorise la communication et apporte sérénité.",
    chakras: ["Gorge"],
    signesAstrologiques: ["Sagittaire", "Poissons", "Verseau"],
    intentions: ["Protection", "Communication", "Purification"],
    purification: "Fumigation uniquement (très sensible à l'eau)",
    rechargement: "Lumière lunaire"
  },
  {
    id: 14,
    nom: "Malachite",
    nomScientifique: "Carbonate de cuivre",
    formuleChimique: "Cu₂CO₃(OH)₂",
    systemeCristallin: "Monoclinique",
    dureteMohs: 4,
    couleur: "Vert malachite",
    origine: "Congo, Russie, Australie",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre des guérisseurs égyptiens et des pharaons. Symbole de transformation et de protection contre les énergies négatives.",
    propriétésÉnergétiques: "Pierre de transformation et de protection, elle absorbe les énergies négatives, stimule le chakra du cœur et favorise le changement positif.",
    chakras: ["Cœur"],
    signesAstrologiques: ["Scorpion", "Capricorne"],
    intentions: ["Transformation", "Protection", "Guérison émotionnelle"],
    purification: "Fumigation, sel indirect (ne jamais mettre dans l'eau)",
    rechargement: "Amas de quartz"
  },
  {
    id: 15,
    nom: "Hématite",
    nomScientifique: "Oxyde de fer",
    formuleChimique: "Fe₂O₃",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 6.5,
    couleur: "Gris métallique",
    origine: "Brésil, Australie, Canada",
    image: "https://images.pexels.com/photos/1573236/pexels-photo-1573236.jpeg",
    histoire: "Son nom vient du grec 'haima' (sang). Les guerriers romains la portaient pour se protéger au combat et renforcer leur courage.",
    propriétésÉnergétiques: "Pierre d'ancrage puissante, elle renforce la confiance en soi, stimule la concentration et protège des énergies négatives. Excellente pour l'ancrage.",
    chakras: ["Racine"],
    signesAstrologiques: ["Bélier", "Scorpion"],
    intentions: ["Ancrage", "Protection", "Confiance"],
    purification: "Fumigation, sel (éviter l'eau prolongée)",
    rechargement: "Amas de quartz, terre"
  },
  {
    id: 16,
    nom: "Sélénite",
    nomScientifique: "Gypse",
    formuleChimique: "CaSO₄·2H₂O",
    systemeCristallin: "Monoclinique",
    dureteMohs: 2,
    couleur: "Blanc translucide",
    origine: "Maroc, Mexique, États-Unis",
    image: "https://images.unsplash.com/photo-1560427450-00fa9481f01e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Nommée d'après Séléné, déesse grecque de la Lune. Pierre de pureté et de clarté spirituelle.",
    propriétésÉnergétiques: "Pierre de purification et de connexion spirituelle, elle nettoie les autres pierres, élève la conscience et favorise la paix intérieure.",
    chakras: ["Couronne"],
    signesAstrologiques: ["Cancer"],
    intentions: ["Purification", "Spiritualité", "Paix"],
    purification: "Fumigation uniquement (se dissout dans l'eau)",
    rechargement: "Lumière lunaire, auto-nettoyante"
  },
  {
    id: 17,
    nom: "Pyrite",
    nomScientifique: "Sulfure de fer",
    formuleChimique: "FeS₂",
    systemeCristallin: "Cubique",
    dureteMohs: 6.5,
    couleur: "Doré métallique",
    origine: "Espagne, Pérou, Italie",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Appelée 'or des fous', elle était utilisée par les Incas comme miroir et symbole de pouvoir solaire.",
    propriétésÉnergétiques: "Pierre de protection et de manifestation, elle attire l'abondance, renforce la volonté et protège des énergies négatives et des manipulations.",
    chakras: ["Plexus solaire"],
    signesAstrologiques: ["Lion"],
    intentions: ["Abondance", "Protection", "Manifestation"],
    purification: "Fumigation (éviter l'eau car elle s'oxyde)",
    rechargement: "Soleil, amas de quartz"
  },
  {
    id: 18,
    nom: "Agate",
    nomScientifique: "Calcédoine",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Multicolore",
    origine: "Brésil, Inde, Madagascar",
    image: "https://images.unsplash.com/photo-1627768919962-fb6af351759c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre d'équilibre utilisée depuis l'Antiquité. Les Perses la brûlaient pour détourner les tempêtes.",
    propriétésÉnergétiques: "Pierre d'équilibre et de stabilité, elle harmonise le yin et le yang, apaise les angoisses et renforce la confiance en soi.",
    chakras: ["Racine", "Sacré"],
    signesAstrologiques: ["Gémeaux"],
    intentions: ["Équilibre", "Stabilité", "Stress"],
    purification: "Eau, fumigation, sel",
    rechargement: "Soleil, amas de quartz"
  },
  {
    id: 19,
    nom: "Fluorite",
    nomScientifique: "Fluorure de calcium",
    formuleChimique: "CaF₂",
    systemeCristallin: "Cubique",
    dureteMohs: 4,
    couleur: "Violet, vert, bleu",
    origine: "Chine, Mexique, Afrique du Sud",
    image: "https://images.unsplash.com/photo-1627768919962-fb6af351759c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre des érudits et des alchimistes, utilisée pour clarifier l'esprit et favoriser la concentration intellectuelle.",
    propriétésÉnergétiques: "Pierre de clarté mentale et de concentration, elle structure les pensées, favorise l'apprentissage et protège des influences psychiques négatives.",
    chakras: ["Troisième œil", "Couronne"],
    signesAstrologiques: ["Verseau", "Poissons"],
    intentions: ["Concentration", "Clarté mentale", "Stress"],
    purification: "Fumigation, eau distillée courte durée",
    rechargement: "Lumière lunaire, amas de quartz"
  },
  {
    id: 20,
    nom: "Sodalite",
    nomScientifique: "Silicate de sodium",
    formuleChimique: "Na₄Al₃(SiO₄)₃Cl",
    systemeCristallin: "Cubique",
    dureteMohs: 5.5,
    couleur: "Bleu profond",
    origine: "Brésil, Canada, Inde",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Découverte au Groenland, elle était considérée comme une pierre de logique et de vérité par les peuples nordiques.",
    propriétésÉnergétiques: "Pierre de logique et de communication, elle calme l'esprit, favorise la pensée rationnelle et apaise les angoisses.",
    chakras: ["Gorge", "Troisième œil"],
    signesAstrologiques: ["Sagittaire"],
    intentions: ["Communication", "Logique", "Stress"],
    purification: "Fumigation, eau courte durée",
    rechargement: "Lumière lunaire"
  },
  {
    id: 21,
    nom: "Rhodonite",
    nomScientifique: "Silicate de manganèse",
    formuleChimique: "(Mn,Fe,Mg,Ca)SiO₃",
    systemeCristallin: "Triclinique",
    dureteMohs: 6,
    couleur: "Rose à rouge",
    origine: "Russie, Australie, Pérou",
    image: "https://images.unsplash.com/photo-1627768919962-fb6af351759c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre de guérison émotionnelle utilisée en Russie impériale comme pierre de réconciliation.",
    propriétésÉnergétiques: "Pierre de compassion et de guérison émotionnelle, elle libère les blessures du passé, favorise le pardon et équilibre les émotions.",
    chakras: ["Cœur"],
    signesAstrologiques: ["Taureau"],
    intentions: ["Guérison émotionnelle", "Pardon", "Compassion"],
    purification: "Eau, fumigation",
    rechargement: "Lumière lunaire, amas de quartz"
  },
  {
    id: 22,
    nom: "Calcite Orange",
    nomScientifique: "Carbonate de calcium",
    formuleChimique: "CaCO₃",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 3,
    couleur: "Orange",
    origine: "Mexique, États-Unis, Pérou",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre d'énergie et de créativité, utilisée par les artisans mayas pour stimuler l'inspiration.",
    propriétésÉnergétiques: "Pierre de joie et de créativité, elle stimule l'énergie vitale, favorise l'optimisme et aide à surmonter la dépression.",
    chakras: ["Sacré"],
    signesAstrologiques: ["Cancer"],
    intentions: ["Créativité", "Joie", "Énergie"],
    purification: "Fumigation (sensible à l'eau)",
    rechargement: "Soleil doux, amas de quartz"
  },
  {
    id: 23,
    nom: "Grenat",
    nomScientifique: "Silicate",
    formuleChimique: "X₃Y₂(SiO₄)₃",
    systemeCristallin: "Cubique",
    dureteMohs: 7.5,
    couleur: "Rouge",
    origine: "Inde, Sri Lanka, Afrique",
    image: "https://images.unsplash.com/photo-1627768919962-fb6af351759c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre de passion utilisée par les croisés pour se protéger au combat. Symbole de fidélité et d'engagement.",
    propriétésÉnergétiques: "Pierre de vitalité et de passion, elle stimule l'énergie sexuelle, renforce le courage et favorise l'engagement.",
    chakras: ["Racine", "Sacré"],
    signesAstrologiques: ["Bélier", "Scorpion"],
    intentions: ["Passion", "Vitalité", "Courage"],
    purification: "Eau, fumigation, sel",
    rechargement: "Soleil, terre"
  },
  {
    id: 24,
    nom: "Chrysocolle",
    nomScientifique: "Silicate de cuivre hydraté",
    formuleChimique: "(Cu,Al)₂H₂Si₂O₅(OH)₄·nH₂O",
    systemeCristallin: "Amorphe",
    dureteMohs: 2.5,
    couleur: "Bleu-vert",
    origine: "Pérou, Arizona, Congo",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre de communication utilisée par les anciennes civilisations d'Amérique du Sud pour favoriser la diplomatie.",
    propriétésÉnergétiques: "Pierre de communication et de féminité, elle favorise l'expression émotionnelle, apaise les tensions et soutient les cycles féminins.",
    chakras: ["Gorge", "Cœur"],
    signesAstrologiques: ["Taureau", "Gémeaux", "Vierge"],
    intentions: ["Communication", "Féminité", "Règles"],
    purification: "Fumigation uniquement (très fragile)",
    rechargement: "Lumière lunaire"
  },
  {
    id: 25,
    nom: "Unakite",
    nomScientifique: "Roche métamorphique",
    formuleChimique: "Feldspath + Épidote + Quartz",
    systemeCristallin: "Mixte",
    dureteMohs: 7,
    couleur: "Vert et rose",
    origine: "États-Unis, Afrique du Sud, Brésil",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre d'équilibre émotionnel découverte dans les montagnes Unaka. Symbole d'harmonie entre le cœur et l'esprit.",
    propriétésÉnergétiques: "Pierre d'équilibre et de régénération, elle harmonise les émotions, favorise la guérison et aide à libérer les blocages émotionnels.",
    chakras: ["Cœur"],
    signesAstrologiques: ["Scorpion"],
    intentions: ["Équilibre", "Guérison", "Régénération"],
    purification: "Eau, fumigation",
    rechargement: "Soleil doux, terre"
  },
  {
    id: 26,
    nom: "Howlite",
    nomScientifique: "Silicate de bore",
    formuleChimique: "Ca₂B₅SiO₉(OH)₅",
    systemeCristallin: "Monoclinique",
    dureteMohs: 3.5,
    couleur: "Blanc",
    origine: "Canada, États-Unis",
    image: "https://images.unsplash.com/photo-1560427450-00fa9481f01e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre de calme découverte au Canada au XIXe siècle. Utilisée pour favoriser le sommeil paisible.",
    propriétésÉnergétiques: "Pierre de calme et de patience, elle apaise les émotions, favorise le sommeil réparateur et aide à gérer la colère et le stress.",
    chakras: ["Couronne"],
    signesAstrologiques: ["Gémeaux"],
    intentions: ["Calme", "Sommeil", "Stress"],
    purification: "Fumigation, eau courte durée",
    rechargement: "Lumière lunaire"
  },
  {
    id: 27,
    nom: "Péridot",
    nomScientifique: "Olivine",
    formuleChimique: "(Mg,Fe)₂SiO₄",
    systemeCristallin: "Orthorhombique",
    dureteMohs: 6.5,
    couleur: "Vert olive",
    origine: "Égypte, Pakistan, Myanmar",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre solaire des Égyptiens, associée au dieu Râ. Cléopâtre adorait cette pierre qu'elle considérait comme protectrice.",
    propriétésÉnergétiques: "Pierre de renouveau et de purification, elle libère les vieux schémas, attire l'abondance et favorise la croissance personnelle.",
    chakras: ["Cœur", "Plexus solaire"],
    signesAstrologiques: ["Lion", "Vierge"],
    intentions: ["Renouveau", "Abondance", "Purification"],
    purification: "Eau, fumigation",
    rechargement: "Soleil, amas de quartz"
  },
  {
    id: 28,
    nom: "Chrysoprase",
    nomScientifique: "Calcédoine",
    formuleChimique: "SiO₂",
    systemeCristallin: "Rhomboédrique",
    dureteMohs: 7,
    couleur: "Vert pomme",
    origine: "Australie, Brésil, Madagascar",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre précieuse d'Alexandre le Grand qui la portait au combat. Symbole de victoire et de protection divine.",
    propriétésÉnergétiques: "Pierre de joie et d'optimisme, elle ouvre le cœur, favorise l'acceptation de soi et aide à libérer les émotions refoulées.",
    chakras: ["Cœur"],
    signesAstrologiques: ["Balance"],
    intentions: ["Joie", "Acceptation", "Guérison émotionnelle"],
    purification: "Eau, fumigation",
    rechargement: "Soleil doux, lumière lunaire"
  },
  {
    id: 29,
    nom: "Aigue-Marine",
    nomScientifique: "Béryl",
    formuleChimique: "Be₃Al₂Si₆O₁₈",
    systemeCristallin: "Hexagonal",
    dureteMohs: 7.5,
    couleur: "Bleu clair",
    origine: "Brésil, Pakistan, Madagascar",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    histoire: "Pierre des marins et des voyageurs, elle était considérée comme un talisman protecteur contre les dangers de la mer.",
    propriétésÉnergétiques: "Pierre de communication et de courage, elle apaise les peurs, favorise l'expression authentique et clarifie la communication.",
    chakras: ["Gorge"],
    signesAstrologiques: ["Gémeaux", "Poissons", "Verseau"],
    intentions: ["Communication", "Courage", "Clarté"],
    purification: "Eau, fumigation, sel",
    rechargement: "Lumière lunaire, eau de mer"
  },
  {
    id: 30,
    nom: "Shungite",
    nomScientifique: "Carbone minéralisé",
    formuleChimique: "C (98%)",
    systemeCristallin: "Amorphe",
    dureteMohs: 4,
    couleur: "Noir",
    origine: "Russie (Carélie)",
    image: "https://images.pexels.com/photos/1573236/pexels-photo-1573236.jpeg",
    histoire: "Pierre rare de Russie, vieille de 2 milliards d'années. Utilisée par Pierre le Grand pour purifier l'eau de ses armées.",
    propriétésÉnergétiques: "Pierre de purification puissante, elle protège des ondes électromagnétiques, purifie l'eau et renforce le système immunitaire.",
    chakras: ["Racine"],
    signesAstrologiques: ["Scorpion", "Capricorne"],
    intentions: ["Protection électromagnétique", "Purification", "Ancrage"],
    purification: "Eau courante régulière",
    rechargement: "Soleil, terre"
  }
];

export const articles = [
  {
    id: 1,
    titre: "Top des pierres naturelles quand on a ses règles",
    slug: "pierres-naturelles-regles",
    auteur: "Équipe Le Savoir des Cristaux",
    date: "2025-01-15",
    categorie: "Bien-être féminin",
    tempsDeLecture: "8 min",
    image: "https://images.unsplash.com/photo-1560427450-00fa9481f01e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    extrait: "Les menstruations peuvent être accompagnées de douleurs, de fatigue et de déséquilibres émotionnels. Découvrez les pierres naturelles qui peuvent vous accompagner pendant cette période.",
    contenu: `<h2>Introduction</h2>
    <p>Les menstruations sont une période naturelle mais souvent inconfortable pour de nombreuses femmes. La lithothérapie propose un accompagnement doux et naturel pour soulager les symptômes physiques et émotionnels liés aux règles.</p>
    
    <h2>Les pierres pour soulager les douleurs menstruelles</h2>
    
    <h3>1. Jaspe Rouge - La pierre de vitalité</h3>
    <p>Le jaspe rouge est particulièrement efficace pour stimuler la circulation sanguine et atténuer les crampes menstruelles. Pierre d'ancrage puissante, elle reconnecte à la Terre et aide à supporter les douleurs physiques.</p>
    <p><strong>Utilisation :</strong> Placer une pierre de jaspe rouge sur le bas-ventre pendant 15-20 minutes, en position allongée.</p>
    
    <h3>2. Pierre de Lune - L'équilibrante hormonale</h3>
    <p>La pierre de lune est la pierre féminine par excellence. Elle régule les cycles menstruels, équilibre les hormones et apaise les variations émotionnelles liées aux règles.</p>
    <p><strong>Utilisation :</strong> Porter en pendentif près du cœur ou garder dans la poche pendant toute la période menstruelle.</p>
    
    <h3>3. Cornaline - L'énergisante</h3>
    <p>La cornaline combat la fatigue menstruelle et redonne de l'énergie. Elle stimule le chakra sacré, siège de la créativité et de la féminité.</p>
    <p><strong>Utilisation :</strong> Méditer avec la pierre sur le chakra sacré (bas-ventre) ou la porter en bijou.</p>
    
    <h2>Les pierres pour l'équilibre émotionnel</h2>
    
    <h3>4. Quartz Rose - La douce compassion</h3>
    <p>Le quartz rose apporte douceur et compassion envers soi-même pendant cette période délicate. Il calme les émotions et favorise l'auto-acceptation.</p>
    
    <h3>5. Chrysocolle - La communication des émotions</h3>
    <p>La chrysocolle aide à exprimer les émotions refoulées et soutient particulièrement les femmes pendant leurs cycles menstruels.</p>
    
    <h2>Protocole de soin lithothérapeutique</h2>
    <ol>
      <li>Purifier vos pierres avant la première utilisation</li>
      <li>Créer un espace calme pour vous allonger</li>
      <li>Placer les pierres sur les zones concernées (bas-ventre, chakra sacré)</li>
      <li>Respirer profondément pendant 15-20 minutes</li>
      <li>Remercier les pierres après utilisation</li>
    </ol>
    
    <h2>Précautions importantes</h2>
    <p><strong>Avertissement :</strong> La lithothérapie est une approche complémentaire et ne remplace en aucun cas un traitement médical. Consultez un professionnel de santé en cas de douleurs menstruelles intenses ou inhabituelles.</p>
    
    <h2>Conclusion</h2>
    <p>Les pierres naturelles offrent un soutien doux et naturel pendant les menstruations. Expérimentez avec différentes pierres pour découvrir celles qui vous conviennent le mieux.</p>`
  },
  {
    id: 2,
    titre: "Top des pierres quand on est stressé",
    slug: "pierres-anti-stress",
    auteur: "Équipe Le Savoir des Cristaux",
    date: "2025-01-10",
    categorie: "Gestion du stress",
    tempsDeLecture: "7 min",
    image: "https://images.unsplash.com/photo-1627768919962-fb6af351759c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    extrait: "Le stress est le mal du siècle. Découvrez les pierres naturelles les plus efficaces pour retrouver calme, sérénité et équilibre intérieur.",
    contenu: `<h2>Comprendre le stress et ses effets</h2>
    <p>Le stress chronique affecte notre santé physique, mentale et émotionnelle. La lithothérapie propose des outils naturels pour rééquilibrer nos énergies et retrouver la paix intérieure.</p>
    
    <h2>Les pierres anti-stress essentielles</h2>
    
    <h3>1. Améthyste - La reine de l'apaisement</h3>
    <p>L'améthyste est LA pierre anti-stress par excellence. Elle calme le mental agité, dissipe l'anxiété et favorise un sommeil réparateur.</p>
    <p><strong>Propriétés :</strong> Apaise les angoisses, favorise la méditation, calme les pensées obsessionnelles.</p>
    <p><strong>Utilisation :</strong> Placer sous l'oreiller pour un sommeil paisible ou méditer avec elle 10 minutes par jour.</p>
    
    <h3>2. Labradorite - Le bouclier protecteur</h3>
    <p>La labradorite est indispensable pour les personnes sensibles aux énergies environnantes. Elle absorbe les énergies négatives et protège du stress externe.</p>
    <p><strong>Utilisation :</strong> Porter quotidiennement en pendentif ou bracelet, surtout dans les environnements stressants.</p>
    
    <h3>3. Howlite - La pierre du calme profond</h3>
    <p>La howlite apaise les émotions intenses, calme la colère et réduit les tensions. Excellente pour gérer les situations conflictuelles.</p>
    
    <h3>4. Lapis-Lazuli - La sagesse tranquille</h3>
    <p>Le lapis-lazuli aide à prendre du recul face aux situations stressantes. Il favorise la communication sereine et la résolution de conflits.</p>
    
    <h3>5. Aventurine Verte - L'apaisante du cœur</h3>
    <p>L'aventurine verte calme les émotions du chakra du cœur, dissipe les inquiétudes et apporte une énergie apaisante.</p>
    
    <h2>Techniques d'utilisation anti-stress</h2>
    
    <h3>Méditation avec les pierres</h3>
    <ol>
      <li>Choisir un endroit calme</li>
      <li>Tenir la pierre dans la main gauche (réceptrice)</li>
      <li>Respirer profondément pendant 5-10 minutes</li>
      <li>Visualiser l'énergie apaisante de la pierre</li>
    </ol>
    
    <h3>Élixir de pierre (méthode indirecte)</h3>
    <p>Placer une pierre purifiée dans un verre d'eau pendant 2-3 heures (vérifier que la pierre n'est pas toxique). Boire l'eau énergisée tout au long de la journée.</p>
    
    <h3>Grille de cristaux anti-stress</h3>
    <p>Créer une disposition géométrique de pierres dans votre espace de vie ou de travail pour maintenir une énergie apaisante constante.</p>
    
    <h2>Combinaisons de pierres recommandées</h2>
    <ul>
      <li><strong>Stress professionnel :</strong> Labradorite + Fluorite + Améthyste</li>
      <li><strong>Anxiété généralisée :</strong> Améthyste + Howlite + Quartz Rose</li>
      <li><strong>Stress émotionnel :</strong> Aventurine + Lapis-Lazuli + Agate</li>
    </ul>
    
    <h2>Entretien de vos pierres anti-stress</h2>
    <p>Les pierres anti-stress absorbent beaucoup d'énergies négatives. Il est essentiel de les purifier régulièrement :</p>
    <ul>
      <li>Purification hebdomadaire : fumigation à la sauge ou Palo Santo</li>
      <li>Rechargement : lumière lunaire de pleine lune ou amas de quartz</li>
    </ul>
    
    <h2>Conclusion</h2>
    <p>La lithothérapie offre des outils puissants pour gérer le stress quotidien. Intégrez ces pierres dans votre routine de bien-être pour retrouver calme et sérénité.</p>`
  },
  {
    id: 3,
    titre: "Le guide complet des 7 chakras",
    slug: "guide-7-chakras",
    auteur: "Équipe Le Savoir des Cristaux",
    date: "2025-01-05",
    categorie: "Spiritualité",
    tempsDeLecture: "12 min",
    image: "https://images.unsplash.com/photo-1625479610681-f789345a8157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjcnlzdGFsc3xlbnwwfHx8fDE3NjUzODg1MzZ8MA&ixlib=rb-4.1.0&q=85",
    extrait: "Découvrez tout ce qu'il faut savoir sur les 7 chakras principaux : leur rôle, leurs déséquilibres et les pierres associées pour les harmoniser.",
    contenu: `<h2>Introduction aux chakras</h2>
    <p>Les chakras sont des centres énergétiques situés le long de la colonne vertébrale. En sanskrit, 'chakra' signifie 'roue' ou 'disque'. Ces vortex d'énergie régulent notre santé physique, émotionnelle et spirituelle.</p>
    
    <h2>1. Chakra Racine (Muladhara)</h2>
    <p><strong>Localisation :</strong> Base de la colonne vertébrale</p>
    <p><strong>Couleur :</strong> Rouge</p>
    <p><strong>Élément :</strong> Terre</p>
    <p><strong>Fonction :</strong> Ancrage, sécurité, survie, stabilité matérielle</p>
    
    <h3>Signes de déséquilibre</h3>
    <ul>
      <li>Manque de confiance en soi</li>
      <li>Anxiété et peurs</li>
      <li>Problèmes financiers récurrents</li>
      <li>Fatigue chronique</li>
    </ul>
    
    <h3>Pierres du chakra Racine</h3>
    <ul>
      <li><strong>Jaspe Rouge :</strong> Ancrage puissant et vitalité</li>
      <li><strong>Hématite :</strong> Protection et stabilité</li>
      <li><strong>Obsidienne Noire :</strong> Libération des peurs profondes</li>
      <li><strong>Grenat :</strong> Force vitale et passion</li>
    </ul>
    
    <h2>2. Chakra Sacré (Svadhisthana)</h2>
    <p><strong>Localisation :</strong> Bas-ventre, sous le nombril</p>
    <p><strong>Couleur :</strong> Orange</p>
    <p><strong>Élément :</strong> Eau</p>
    <p><strong>Fonction :</strong> Créativité, sexualité, émotions, plaisir</p>
    
    <h3>Signes de déséquilibre</h3>
    <ul>
      <li>Blocages créatifs</li>
      <li>Difficultés relationnelles</li>
      <li>Problèmes de libido</li>
      <li>Émotions refoulées</li>
    </ul>
    
    <h3>Pierres du chakra Sacré</h3>
    <ul>
      <li><strong>Cornaline :</strong> Créativité et énergie sexuelle</li>
      <li><strong>Calcite Orange :</strong> Joie et optimisme</li>
      <li><strong>Pierre de Lune :</strong> Équilibre émotionnel et féminité</li>
    </ul>
    
    <h2>3. Chakra du Plexus Solaire (Manipura)</h2>
    <p><strong>Localisation :</strong> Au-dessus du nombril</p>
    <p><strong>Couleur :</strong> Jaune</p>
    <p><strong>Élément :</strong> Feu</p>
    <p><strong>Fonction :</strong> Pouvoir personnel, confiance, volonté, digestion</p>
    
    <h3>Signes de déséquilibre</h3>
    <ul>
      <li>Manque de confiance en soi</li>
      <li>Difficulté à prendre des décisions</li>
      <li>Problèmes digestifs</li>
      <li>Sentiment d'impuissance</li>
    </ul>
    
    <h3>Pierres du chakra du Plexus Solaire</h3>
    <ul>
      <li><strong>Citrine :</strong> Confiance et abondance</li>
      <li><strong>Œil de Tigre :</strong> Force de volonté et protection</li>
      <li><strong>Pyrite :</strong> Manifestation et pouvoir personnel</li>
    </ul>
    
    <h2>4. Chakra du Cœur (Anahata)</h2>
    <p><strong>Localisation :</strong> Centre de la poitrine</p>
    <p><strong>Couleur :</strong> Vert/Rose</p>
    <p><strong>Élément :</strong> Air</p>
    <p><strong>Fonction :</strong> Amour, compassion, pardon, relations</p>
    
    <h3>Signes de déséquilibre</h3>
    <ul>
      <li>Difficulté à aimer ou recevoir l'amour</li>
      <li>Rancœur et amertume</li>
      <li>Isolement émotionnel</li>
      <li>Dépendance affective</li>
    </ul>
    
    <h3>Pierres du chakra du Cœur</h3>
    <ul>
      <li><strong>Quartz Rose :</strong> Amour inconditionnel et guérison émotionnelle</li>
      <li><strong>Aventurine Verte :</strong> Croissance émotionnelle</li>
      <li><strong>Malachite :</strong> Transformation du cœur</li>
      <li><strong>Rhodonite :</strong> Pardon et compassion</li>
    </ul>
    
    <h2>5. Chakra de la Gorge (Vishuddha)</h2>
    <p><strong>Localisation :</strong> Gorge</p>
    <p><strong>Couleur :</strong> Bleu clair</p>
    <p><strong>Élément :</strong> Éther</p>
    <p><strong>Fonction :</strong> Communication, expression, vérité, créativité verbale</p>
    
    <h3>Signes de déséquilibre</h3>
    <ul>
      <li>Difficulté à s'exprimer</li>
      <li>Peur du jugement</li>
      <li>Mensonges ou manipulation</li>
      <li>Problèmes de thyroïde</li>
    </ul>
    
    <h3>Pierres du chakra de la Gorge</h3>
    <ul>
      <li><strong>Lapis-Lazuli :</strong> Communication authentique</li>
      <li><strong>Turquoise :</strong> Expression claire et protection</li>
      <li><strong>Aigue-Marine :</strong> Courage de parler</li>
      <li><strong>Amazonite :</strong> Communication apaisée</li>
    </ul>
    
    <h2>6. Chakra du Troisième Œil (Ajna)</h2>
    <p><strong>Localisation :</strong> Entre les sourcils</p>
    <p><strong>Couleur :</strong> Indigo</p>
    <p><strong>Élément :</strong> Lumière</p>
    <p><strong>Fonction :</strong> Intuition, clairvoyance, sagesse, imagination</p>
    
    <h3>Signes de déséquilibre</h3>
    <ul>
      <li>Manque d'intuition</li>
      <li>Difficulté à visualiser</li>
      <li>Cauchemars récurrents</li>
      <li>Manque de clarté mentale</li>
    </ul>
    
    <h3>Pierres du chakra du Troisième Œil</h3>
    <ul>
      <li><strong>Améthyste :</strong> Intuition et sagesse spirituelle</li>
      <li><strong>Lapis-Lazuli :</strong> Vision intérieure</li>
      <li><strong>Fluorite :</strong> Clarté mentale</li>
      <li><strong>Sodalite :</strong> Logique intuitive</li>
    </ul>
    
    <h2>7. Chakra Couronne (Sahasrara)</h2>
    <p><strong>Localisation :</strong> Sommet du crâne</p>
    <p><strong>Couleur :</strong> Violet/Blanc</p>
    <p><strong>Élément :</strong> Pensée pure</p>
    <p><strong>Fonction :</strong> Connexion spirituelle, conscience universelle, illumination</p>
    
    <h3>Signes de déséquilibre</h3>
    <ul>
      <li>Sentiment de déconnexion spirituelle</li>
      <li>Cynisme et matérialisme excessif</li>
      <li>Dépression existentielle</li>
      <li>Fermeture d'esprit</li>
    </ul>
    
    <h3>Pierres du chakra Couronne</h3>
    <ul>
      <li><strong>Améthyste :</strong> Connexion spirituelle</li>
      <li><strong>Sélénite :</strong> Purification et élévation</li>
      <li><strong>Howlite :</strong> Calme mental et méditation</li>
    </ul>
    
    <h2>Comment équilibrer vos chakras avec les pierres</h2>
    
    <h3>Méditation des 7 chakras</h3>
    <ol>
      <li>S'allonger confortablement</li>
      <li>Placer une pierre correspondante sur chaque chakra</li>
      <li>Respirer profondément pendant 20-30 minutes</li>
      <li>Visualiser chaque chakra s'illuminer de sa couleur</li>
      <li>Terminer en remerciant les pierres</li>
    </ol>
    
    <h3>Travail ciblé sur un chakra</h3>
    <p>Si vous identifiez un chakra déséquilibré, concentrez-vous sur lui pendant 1-2 semaines :</p>
    <ul>
      <li>Porter la pierre correspondante quotidiennement</li>
      <li>Méditer 10 minutes par jour avec cette pierre</li>
      <li>Pratiquer des affirmations liées à ce chakra</li>
    </ul>
    
    <h2>Conclusion</h2>
    <p>L'équilibre des chakras est un voyage continu. Les pierres naturelles sont des alliées précieuses pour harmoniser vos centres énergétiques et favoriser votre bien-être holistique.</p>`
  },
  {
    id: 4,
    titre: "Les méthodes de purification expliquées",
    slug: "methodes-purification-pierres",
    auteur: "Équipe Le Savoir des Cristaux",
    date: "2025-01-01",
    categorie: "Pratique",
    tempsDeLecture: "10 min",
    image: "https://images.unsplash.com/photo-1584715787746-75b93b83bf14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5lcmFsc3xlbnwwfHx8fDE3NjUzODg1NDF8MA&ixlib=rb-4.1.0&q=85",
    extrait: "Guide complet des différentes méthodes de purification et de rechargement des pierres naturelles. Apprenez à entretenir correctement vos minéraux.",
    contenu: `<h2>Pourquoi purifier ses pierres ?</h2>
    <p>Les pierres naturelles absorbent et émettent des énergies. Lors de leur extraction, transport, et utilisation, elles accumulent des énergies de toutes sortes. La purification permet de :</p>
    <ul>
      <li>Éliminer les énergies négatives accumulées</li>
      <li>Restaurer les propriétés énergétiques originales</li>
      <li>Préparer la pierre à un nouveau travail énergétique</li>
      <li>Maintenir l'efficacité de vos pierres</li>
    </ul>
    
    <h2>Quand purifier vos pierres ?</h2>
    <ul>
      <li><strong>À la réception :</strong> Toute nouvelle pierre doit être purifiée</li>
      <li><strong>Après utilisation intense :</strong> Séances de méditation, soins énergétiques</li>
      <li><strong>Régulièrement :</strong> Une fois par semaine pour les pierres portées quotidiennement</li>
      <li><strong>Intuitivement :</strong> Quand vous sentez que la pierre est "lourde"</li>
    </ul>
    
    <h2>Méthodes de purification</h2>
    
    <h3>1. Purification par l'eau</h3>
    <p><strong>Principe :</strong> L'eau courante emporte les énergies négatives.</p>
    <p><strong>Méthode :</strong></p>
    <ol>
      <li>Placer la pierre sous l'eau courante froide pendant 2-3 minutes</li>
      <li>Visualiser les énergies négatives s'écouler</li>
      <li>Sécher délicatement avec un chiffon doux</li>
    </ol>
    <p><strong>⚠️ Pierres compatibles :</strong> Quartz, jaspe, améthyste, agate</p>
    <p><strong>❌ Pierres incompatibles :</strong> Sélénite, malachite, pyrite, lapis-lazuli, turquoise, hématite (rouille)</p>
    
    <h3>2. Purification par le sel</h3>
    <p><strong>Principe :</strong> Le sel absorbe et neutralise les énergies négatives.</p>
    
    <h4>Méthode directe (pour pierres résistantes)</h4>
    <ol>
      <li>Remplir un bol de gros sel marin non traité</li>
      <li>Enterrer complètement la pierre dans le sel</li>
      <li>Laisser reposer 3-4 heures minimum (ou toute une nuit)</li>
      <li>Rincer à l'eau claire et sécher</li>
      <li>Jeter le sel utilisé (ne pas réutiliser)</li>
    </ol>
    
    <h4>Méthode indirecte (pour pierres fragiles)</h4>
    <ol>
      <li>Placer la pierre dans un petit récipient en verre</li>
      <li>Placer ce récipient dans un bol plus grand rempli de sel</li>
      <li>Laisser reposer 2-3 heures</li>
    </ol>
    <p><strong>✅ Pierres compatibles :</strong> Quartz, jaspe, œil de tigre</p>
    <p><strong>❌ Pierres incompatibles :</strong> Pierres poreuses, pyrite, hématite</p>
    
    <h3>3. Purification par la fumigation</h3>
    <p><strong>Principe :</strong> La fumée purifie en élevant les vibrations.</p>
    <p><strong>Méthode :</strong></p>
    <ol>
      <li>Allumer de la sauge blanche, du Palo Santo ou de l'encens naturel</li>
      <li>Passer la pierre dans la fumée pendant 30 secondes à 1 minute</li>
      <li>Visualiser la purification</li>
      <li>Aérer la pièce après</li>
    </ol>
    <p><strong>✅ Avantage :</strong> Fonctionne pour TOUTES les pierres, même les plus fragiles</p>
    <p><strong>Recommandé pour :</strong> Sélénite, turquoise, lapis-lazuli, malachite</p>
    
    <h3>4. Purification par le son</h3>
    <p><strong>Principe :</strong> Les vibrations sonores réalignent les fréquences de la pierre.</p>
    <p><strong>Méthode :</strong></p>
    <ul>
      <li><strong>Bol tibétain :</strong> Faire sonner le bol près de la pierre pendant 5 minutes</li>
      <li><strong>Tingsha :</strong> Faire tinter les cymbales au-dessus de la pierre</li>
      <li><strong>Diapason :</strong> Utiliser un diapason thérapeutique</li>
    </ul>
    <p><strong>✅ Avantage :</strong> Méthode douce et universelle</p>
    
    <h3>5. Purification par la terre</h3>
    <p><strong>Principe :</strong> La Terre-Mère absorbe et transmute les énergies.</p>
    <p><strong>Méthode :</strong></p>
    <ol>
      <li>Enterrer la pierre dans la terre pendant 24 heures minimum (jusqu'à une semaine pour une purification profonde)</li>
      <li>Marquer l'emplacement pour retrouver la pierre</li>
      <li>Déterrer délicatement et rincer à l'eau</li>
    </ol>
    <p><strong>✅ Idéal pour :</strong> Pierres d'ancrage (jaspe rouge, hématite, obsidienne)</p>
    
    <h2>Méthodes de rechargement</h2>
    <p>Après purification, les pierres doivent être rechargées pour retrouver leur pleine puissance.</p>
    
    <h3>1. Rechargement par la lumière lunaire</h3>
    <p><strong>Principe :</strong> L'énergie lunaire douce convient à la plupart des pierres.</p>
    <p><strong>Méthode :</strong></p>
    <ol>
      <li>Placer les pierres à l'extérieur ou sur un rebord de fenêtre</li>
      <li>Laisser exposées toute la nuit</li>
      <li>Idéalement pendant la pleine lune (énergie maximale)</li>
    </ol>
    <p><strong>✅ Pierres favorisées :</strong> Pierre de lune, sélénite, améthyste, labradorite</p>
    <p><strong>✅ Avantage :</strong> Convient à TOUTES les pierres</p>
    
    <h3>2. Rechargement par la lumière solaire</h3>
    <p><strong>Principe :</strong> L'énergie solaire puissante revitalise certaines pierres.</p>
    <p><strong>Méthode :</strong></p>
    <ol>
      <li>Exposer les pierres au soleil matinal (avant 11h)</li>
      <li>Durée : 1-2 heures maximum</li>
    </ol>
    <p><strong>✅ Pierres favorisées :</strong> Citrine, œil de tigre, jaspe rouge, cornaline</p>
    <p><strong>❌ Pierres sensibles (décolorent) :</strong> Améthyste, quartz rose, fluorite, aigue-marine</p>
    
    <h3>3. Rechargement par amas de quartz</h3>
    <p><strong>Principe :</strong> Le quartz amplifie et régénère l'énergie.</p>
    <p><strong>Méthode :</strong></p>
    <ol>
      <li>Placer les pierres sur un amas de quartz ou dans une géode d'améthyste</li>
      <li>Laisser reposer minimum 3 heures (idéalement toute une nuit)</li>
    </ol>
    <p><strong>✅ Avantage :</strong> Méthode universelle et douce</p>
    
    <h3>4. Rechargement par la terre</h3>
    <p><strong>Méthode :</strong> Même principe que la purification par la terre (voir ci-dessus)</p>
    
    <h2>Tableau récapitulatif par pierre</h2>
    
    <table border="1" cellpadding="10">
      <tr>
        <th>Pierre</th>
        <th>Purification recommandée</th>
        <th>Rechargement recommandé</th>
      </tr>
      <tr>
        <td>Améthyste</td>
        <td>Eau, fumigation</td>
        <td>Lumière lunaire, amas de quartz</td>
      </tr>
      <tr>
        <td>Quartz Rose</td>
        <td>Eau, sel indirect</td>
        <td>Lumière lunaire, amas de quartz</td>
      </tr>
      <tr>
        <td>Citrine</td>
        <td>Eau, fumigation</td>
        <td>Soleil (court), amas de quartz</td>
      </tr>
      <tr>
        <td>Labradorite</td>
        <td>Eau, fumigation, sel indirect</td>
        <td>Lumière lunaire, amas de quartz</td>
      </tr>
      <tr>
        <td>Sélénite</td>
        <td>Fumigation UNIQUEMENT</td>
        <td>Lumière lunaire, auto-nettoyante</td>
      </tr>
      <tr>
        <td>Lapis-Lazuli</td>
        <td>Fumigation UNIQUEMENT</td>
        <td>Lumière lunaire, amas de quartz</td>
      </tr>
      <tr>
        <td>Turquoise</td>
        <td>Fumigation UNIQUEMENT</td>
        <td>Lumière lunaire</td>
      </tr>
      <tr>
        <td>Pyrite</td>
        <td>Fumigation UNIQUEMENT</td>
        <td>Soleil, amas de quartz</td>
      </tr>
      <tr>
        <td>Hématite</td>
        <td>Fumigation, sel</td>
        <td>Terre, amas de quartz</td>
      </tr>
      <tr>
        <td>Malachite</td>
        <td>Fumigation, sel indirect</td>
        <td>Amas de quartz UNIQUEMENT</td>
      </tr>
    </table>
    
    <h2>Fréquence d'entretien recommandée</h2>
    <ul>
      <li><strong>Pierres portées quotidiennement :</strong> Purification hebdomadaire</li>
      <li><strong>Pierres de méditation :</strong> Après chaque utilisation</li>
      <li><strong>Pierres d'exposition :</strong> Une fois par mois</li>
      <li><strong>Pierres de protection (labradorite) :</strong> 2 fois par semaine minimum</li>
    </ul>
    
    <h2>Erreurs courantes à éviter</h2>
    <ul>
      <li>❌ Mettre des pierres sensibles dans l'eau</li>
      <li>❌ Exposer des pierres fragiles au soleil direct</li>
      <li>❌ Réutiliser le sel de purification</li>
      <li>❌ Négliger l'entretien régulier</li>
      <li>❌ Purifier pendant la période des règles (énergie instable)</li>
    </ul>
    
    <h2>Conclusion</h2>
    <p>L'entretien régulier de vos pierres est essentiel pour maintenir leur efficacité énergétique. Choisissez les méthodes adaptées à chaque pierre et écoutez votre intuition pour déterminer quand purifier et recharger vos précieux minéraux.</p>`
  },
  {
    id: 5,
    titre: "Sommeil agité : 3 pierres indispensables pour retrouver des nuits paisibles",
    slug: "pierres-naturelles-sommeil-insomnie",
    auteur: "Équipe Le Savoir des Cristaux",
    date: "2025-12-17",
    categorie: "Bien-être",
    tempsDeLecture: "6 min",
    image: "/blog/pierres-sommeil.jpg", 
    metaTitle: "Pierres pour le Sommeil : 3 Cristaux pour Mieux Dormir",
    metaDescription: "Découvrez comment l'Améthyste, le Quartz Rose et la Tourmaline peuvent soulager vos insomnies et apaiser votre mental pour un sommeil réparateur.",
    extrait: "Difficultés à s'endormir ou réveils nocturnes ? La lithothérapie offre des solutions douces pour apaiser votre esprit et retrouver un sommeil réparateur naturellement.",
    contenu: `<h2>Pourquoi utiliser les pierres pour mieux dormir ?</h2>
    <p>Dans un monde où le stress et les écrans perturbent notre rythme biologique, retrouver un sommeil de qualité est devenu un défi quotidien. La lithothérapie, par l'énergie vibratoire des cristaux, permet de créer un environnement propice à la détente et à l'apaisement mental nécessaire avant le coucher.</p>
    
    <h2>1. L'Améthyste : La gardienne de vos nuits</h2>
    <p>L'<strong>Améthyste</strong> est sans aucun doute la pierre la plus célèbre pour le sommeil. Variété de quartz violet, elle est reconnue pour ses propriétés apaisantes sur le système nerveux.</p>
    <h3>Ses bienfaits sur le sommeil :</h3>
    <ul>
        <li>Calme le flux de pensées incessantes (le fameux "vélo" dans la tête).</li>
        <li>Aide à la relaxation musculaire.</li>
        <li>Favorise des rêves paisibles et éloigne les cauchemars.</li>
    </ul>
    <p><strong>Conseil d'utilisation :</strong> Placez une géode ou une pierre polie d'Améthyste sur votre table de chevet pour diffuser une énergie de sérénité dans toute la chambre.</p>
    
    <h2>2. Le Quartz Rose : Pour un endormissement tout en douceur</h2>
    <p>Le <strong>Quartz Rose</strong> rayonne d'une énergie d'amour inconditionnel et de paix intérieure. C'est la pierre idéale pour les personnes dont l'insomnie est liée à une anxiété émotionnelle ou à un sentiment d'insécurité.</p>
    <p>En apportant un sentiment de réconfort, elle permet de lâcher prise sur les tensions de la journée. Elle est particulièrement recommandée dans les chambres d'enfants pour les rassurer au moment de l'extinction des feux.</p>
    
    <h2>3. La Tourmaline Noire : Pour bloquer les ondes et l'anxiété</h2>
    <p>Parfois, le sommeil est perturbé par des énergies environnantes ou le stress électromagnétique (téléphones, Wi-Fi). La <strong>Tourmaline Noire</strong> agit comme un bouclier protecteur.</p>
    <p>En vous ancrant à la terre, elle évite que votre esprit ne s'évapore dans des scénarios anxieux sur le futur. Elle "nettoie" votre champ énergétique pour une nuit sans perturbations.</p>
    
    <h2>Comment purifier vos pierres de sommeil ?</h2>
    <p>Pour que vos cristaux restent efficaces, il est crucial de les libérer des énergies accumulées :</p>
    <ol>
        <li><strong>Nettoyage :</strong> Passez-les sous l'eau claire (attention : ne mouillez pas la Sélénite si vous en utilisez une).</li>
        <li><strong>Rechargement :</strong> Privilégiez la lumière de la Lune, beaucoup plus douce que le soleil pour les pierres liées au repos.</li>
    </ol>
    
    <h2>Conclusion</h2>
    <p>L'Améthyste, le Quartz Rose et la Tourmaline Noire forment un trio puissant pour transformer votre chambre en un sanctuaire de repos. N'oubliez pas que la régularité et l'intention que vous placez dans vos pierres sont les clés de leur efficacité.</p>
    
    <p><em><strong>Avertissement :</strong> Ces conseils ne remplacent pas un avis médical. Si vos troubles du sommeil persistent, consultez un spécialiste.</em></p>`
},
];

// Glossaire
export const glossaire = [
  {
    terme: "Aurique",
    definition: "Relatif à l'aura, le champ énergétique qui entoure le corps physique. Le corps aurique contient les différentes couches énergétiques et émotionnelles de l'être."
  },
  {
    terme: "Chakra",
    definition: "Centre énergétique du corps. Il existe 7 chakras principaux alignés le long de la colonne vertébrale, chacun gouvernant des aspects physiques, émotionnels et spirituels."
  },
  {
    terme: "Purification",
    definition: "Processus de nettoyage énergétique d'une pierre pour éliminer les énergies négatives ou stagnantes qu'elle a absorbées."
  },
  {
    terme: "Rechargement",
    definition: "Action de restaurer l'énergie d'une pierre après purification, généralement par exposition à la lumière lunaire, solaire, ou en la plaçant sur un amas de quartz."
  },
  {
    terme: "Système cristallin",
    definition: "Classification des minéraux selon l'arrangement géométrique de leurs atomes. Les 7 systèmes sont : cubique, hexagonal, rhomboédrique, quadratique, orthorhombique, monoclinique et triclinique."
  },
  {
    terme: "Échelle de Mohs",
    definition: "Échelle de 1 à 10 mesurant la dureté d'un minéral, créée par Friedrich Mohs en 1812. Le talc est 1 (le plus tendre), le diamant est 10 (le plus dur)."
  },
  {
    terme: "Élixir de pierre",
    definition: "Eau énergisée par les vibrations d'une pierre. Méthode directe : pierre dans l'eau. Méthode indirecte : pierre dans un récipient placé dans l'eau (pour pierres toxiques ou solubles)."
  },
  {
    terme: "Lithothérapie",
    definition: "Approche holistique utilisant les propriétés énergétiques des pierres et cristaux pour favoriser l'équilibre physique, émotionnel et spirituel."
  },
  {
    terme: "Ancrage",
    definition: "Action de se connecter à l'énergie de la Terre pour se stabiliser, se sécuriser et rester présent dans l'instant. Les pierres comme le jaspe rouge et l'hématite favorisent l'ancrage."
  },
  {
    terme: "Fumigation",
    definition: "Méthode de purification utilisant la fumée de plantes sacrées (sauge blanche, Palo Santo, encens) pour nettoyer énergétiquement les pierres."
  },
  {
    terme: "Géode",
    definition: "Cavité rocheuse tapissée de cristaux. Les géodes d'améthyste ou de quartz sont utilisées pour purifier et recharger d'autres pierres."
  },
  {
    terme: "Inclusion",
    definition: "Matière minérale, liquide ou gazeuse emprisonnée dans un cristal lors de sa formation. Les inclusions peuvent modifier les propriétés énergétiques de la pierre."
  },
  {
    terme: "Pierre brute",
    definition: "Pierre naturelle non taillée, telle qu'elle est extraite de la terre. Considérée comme ayant une énergie plus brute et puissante."
  },
  {
    terme: "Pierre polie",
    definition: "Pierre ayant subi un polissage pour révéler sa beauté. L'énergie est considérée comme plus douce et harmonieuse."
  },
  {
    terme: "Intuition",
    definition: "Capacité à percevoir et comprendre sans raisonnement logique. Certaines pierres comme l'améthyste et le lapis-lazuli développent l'intuition."
  },
  {
    terme: "Grille de cristaux",
    definition: "Disposition géométrique de plusieurs pierres selon un motif sacré (fleur de vie, métatron) pour amplifier et diriger les énergies vers une intention précise."
  }
];

export const filterOptions = {
  chakras: [
    "Racine",
    "Sacré",
    "Plexus solaire",
    "Cœur",
    "Gorge",
    "Troisième œil",
    "Couronne",
    "Tous les chakras"
  ],
  intentions: [
    "Méditation",
    "Stress",
    "Sommeil",
    "Protection",
    "Amour",
    "Confiance",
    "Ancrage",
    "Intuition",
    "Communication",
    "Spiritualité",
    "Règles",
    "Abondance",
    "Créativité",
    "Guérison émotionnelle"
  ],
  couleurs: [
    "Violet",
    "Rose",
    "Jaune",
    "Vert",
    "Bleu",
    "Rouge",
    "Orange",
    "Noir",
    "Blanc",
    "Gris",
    "Brun",
    "Multicolore"
  ]
};